// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PASSR_EMAIL_SEND_EXPLANATION = "Na email ti po\u0161leme instrukce, jak postupovat.";
export const PASSR_EMAIL_TITLE = "Obnoven\u00ed hesla p\u0159es email";
export const PASSWORD_RESET_WE_SENT_TO_YOUR_EMAIL_INSTRUCTION_HOW_TO_RESET_PASSWORD = "Na emailov\u00fa adresu jsme Ti zaslali instrukce, jak si zadat nov\u00e9 heslo.";
export const WE_CANNOT_SEND_YOU_OLD_PASSWORD_BECAUSE_OF_SECURITY_REASON = "Star\u00e9 heslo ti z bezpe\u010dnostn\u00edch d\u016fvod\u016f zaslat nem\u016f\u017eeme.";
